import { render, staticRenderFns } from "./CustomerSelect.vue?vue&type=template&id=046a7891&"
import script from "./CustomerSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046a7891')) {
      api.createRecord('046a7891', component.options)
    } else {
      api.reload('046a7891', component.options)
    }
    module.hot.accept("./CustomerSelect.vue?vue&type=template&id=046a7891&", function () {
      api.rerender('046a7891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/estimates/CustomerSelect.vue"
export default component.exports